<template>
  <div id="main">
    <!-- ======= Landing Page Section ======= -->
    <section id="home" class="d-flex flex-column justify-content-center">
      <div class="home-container" data-aos="flip-up" data-aos-duration="1000">
        <h1>Welcome to Jotweb</h1>
        <vue-typed-js
          :strings="['Web Development', 'UI/UX Design', 'Data Analysis']"
          :typeSpeed="200"
          :loop="true"
        >
          <p>We offer <span class="typing"></span></p>
        </vue-typed-js>

        <!-- <a name="" id="" class="btn btn-primary d-xl-none" href="/about" role="button">Go to About Section</a> -->
      </div>
    </section>
    <!-- End Landing page section -->
  </div>
</template>

<script>
// @ is an alias to /src
// import HelloWorld from "@/components/HelloWorld.vue"

export default {
  name: "Home",
  components: {}
};
</script>
